export class Mouse {
    public static x: number;
    public static y: number;
}